export default __webpack_public_path__ + "static/N0044-9d52247af9209103967eca2707cb78f9.png";